export default __webpack_public_path__ + "2c31833b8fd53615c76d2bfb623a476d.png";